import React, { Fragment, useState } from 'react';
import { Image, ImageProps, ImageStyle, View } from 'react-native';
import { getInitials } from 'src/libs/user';
import { Title3 } from 'src/components/Typography';
import useStyles from './Avatar.styles';

export type AvatarProps = Omit<ImageProps, 'source'> & {
  source?: ImageProps['source'];
  mode?: 'app' | 'user';
  size?: 'm' | 'l';
  name?: string;
};

export const Avatar: React.FC<AvatarProps> = ({
  name,
  mode = 'user',
  size = 'm',
  source,
  ...props
}) => {
  const s = useStyles({ size });
  const [error, setError] = useState(false);

  const dynamicStyles = [
    mode === 'user' && {
      borderRadius: size === 'm' ? 20 : 24,
    },
    mode === 'app' && {
      borderRadius: 10,
    },
  ];

  return (
    <Fragment>
      {source && !error && (
        <Image
          style={[s.root as ImageStyle, dynamicStyles]}
          onError={() => setError(true)}
          source={source}
          {...props}
        />
      )}
      {(!source || error) && (
        <View style={[s.root, dynamicStyles]}>
          {name && <Title3 numberOfLines={1}>{getInitials(name)}</Title3>}
        </View>
      )}
    </Fragment>
  );
};
